import { jsx as r } from "react/jsx-runtime";

import { useContext as t } from "react";

import e from "../../../utils/classNames/index.js";

import o from "../context/index.js";

const s = ({children: s, className: i, ...a}) => {
    const {close: l, idPrefix: n} = t(o);
    return r("div", {
        ...a,
        className: e("p-m gap-s relative grid shrink-0 auto-cols-fr grid-flow-col border-t border-neutral-300", i, "mt-auto"),
        children: s || r("button", {
            type: "button",
            className: "btn btn-neutral grow",
            onClick: l,
            children: "Close"
        })
    });
};

export { s as default };
//# sourceMappingURL=index.js.map
